import { render, staticRenderFns } from "./prizeManagement.vue?vue&type=template&id=73a54ac6&scoped=true"
import script from "./prizeManagement.vue?vue&type=script&lang=js"
export * from "./prizeManagement.vue?vue&type=script&lang=js"
import style0 from "./prizeManagement.vue?vue&type=style&index=0&id=73a54ac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a54ac6",
  null
  
)

export default component.exports